import { MODAL_TYPES } from "./modal_types"

export const LOADING_TYPES = Object.freeze({
  PATTERN_ROLE_TEMPLATE: "role-template",
  ROLE_LIST_MODAL: MODAL_TYPES.ROLES_LIST_MODAL,
  PATTERN_MODAL: MODAL_TYPES.PATTERN_MODAL,
  TABOO_PATTERN_MODAL: MODAL_TYPES.TABOO_PATTERN_MODAL,
})
